import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private openCounter = signal(0);

  public readonly isLoading = computed(() => this.openCounter() > 0);

  async show() {
    this.openCounter.update(count => count + 1);
  }

  async dismiss() {
    this.openCounter.update(count => Math.max(0, count - 1));
  }
}
